export const PASSWORD_PLACEHOLDER = '&#8226; &#8226; &#8226; &#8226; &#8226; &#8226; &#8226; &#8226;';